import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

// @ts-ignore
Vue.use(Vuetify);

const opts = {
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '409cff',
        secondary: '#c9e2ff',
        terciary: '#003B5D',
      },
    },
  },
};

// @ts-ignore
export default new Vuetify(opts);
